<template>
	<Container>
		<Title>
			{{ $t('Contactos') }}
		</Title>
		<div class="Accordion mb-5">
			<div
				v-for="(category, categoryIndex) in contacts_categories"
				:key="categoryIndex"
			>
				<expander
					:title="category.category_name"
					class="mb-3"
					v-if="category.contacts.length > 0"
				>
					<div class="grid pb-8">
						<Card
							v-for="(contact, contactIndex) in category.contacts"
							:key="contactIndex"
						>
							<div class="font-medium text-secondary mb-4">
								<span>
									{{ contact.position }}
								</span>
							</div>
							<div class="flex">
								<!-- TODO: permitir imagen de contacto -->
								<!-- <div class="w-1/3"> -->
								<!-- <img
										:src="contact.imageTempUrl + '?getImage=1'"
										class="pr-2"
										v-if="contact.imageTempUrl"
									/> -->
								<!-- <img
										src="@/assets/img/contacto.svg"
										width="100%"
										class="pr-2"
									/> -->
								<!-- </div> -->
								<div class="w-full">
									<div
										class="
											flex
											items-center
											font-normal
											pl-1
											py-2
											bg-customLigthGrey
											overflow-auto
										"
										v-if="contact.name"
									>
										<img
											class="mr-2"
											src="@/assets/img/contacto.svg"
											alt="Name"
										/>
										<span>
											{{ contact.name }}
										</span>
									</div>
									<div
										class="
											flex
											items-center
											font-normal
											pl-1
											py-2
											overflow-auto
										"
										v-if="contact.email"
									>
										<img
											class="mr-2"
											src="@/assets/img/email.svg"
											alt="Email"
										/>
										<a
											:href="'mailto:' + contact.email"
											class="text-primary hover:text-primary text-email"
										>
											{{ contact.email }}
										</a>
									</div>
									<div
										class="
											flex
											items-center
											font-normal
											pl-1
											py-2
											bg-customLigthGrey
										"
										v-if="contact.phone"
									>
										<img
											class="mr-2"
											src="@/assets/img/telefono.svg"
											alt="Phone"
										/>
										<a
											:href="'tel:' + contact.phone"
											class="text-primary hover:text-primary"
										>
											{{ contact.phone }}
										</a>
									</div>
								</div>
							</div>
						</Card>
					</div>
				</expander>
			</div>
		</div>
	</Container>
</template>

<script>
import expander from '../../components/Expander.vue'
import gql from 'graphql-tag'

export default {
	apollo: {
		contacts_categories: {
			query: gql`
				query ($country_id: bigint!) {
					contacts_categories(
						where: { country_id: { _eq: $country_id }, active: { _eq: true } }
						order_by: { order: asc }
					) {
						category_name
						contacts(
							where: { active: { _eq: true } }
							order_by: { order: asc }
						) {
							position
							name
							email
							phone
							active
						}
					}
				}
			`,
			variables() {
				return {
					country_id: this.country_id
				}
			}
		}
	},
	data() {
		return {
			country_id: this.$store.state.login.user.country_id
		}
	},
	components: { expander }
}
</script>
